import { action, computed, makeObservable, observable } from 'mobx';
import { MarketStatsFilterOptions } from '@monorepo/community-stats-common';

export type { MarketStatsFilterOptions };

export interface MarketStatsFilterParams {
  accountType?: 'funded' | 'payout' | 'all';
  programId?: string;
  country?: string;
}

export class MarketStatsFilterStore {
  accountType: 'funded' | 'payout' | 'all' = 'all';
  programId: string | null = null;
  country: string | null = null;
  selectedSymbol: string | null = null;
  filterOptions: MarketStatsFilterOptions | null = null;

  constructor() {
    makeObservable(this, {
      accountType: observable,
      programId: observable,
      country: observable,
      selectedSymbol: observable,
      filterOptions: observable,
      filterParams: computed,
      setAccountType: action,
      setProgramId: action,
      setCountry: action,
      setSelectedSymbol: action,
      setFilterOptions: action,
    });
  }

  get filterParams(): MarketStatsFilterParams {
    return {
      accountType: this.accountType,
      programId: this.programId ?? undefined,
      country: this.country ?? undefined,
    };
  }

  setAccountType(value: 'funded' | 'payout' | 'all'): void {
    this.accountType = value;
  }

  setProgramId(value: string | null): void {
    this.programId = value;
  }

  setCountry(value: string | null): void {
    this.country = value;
  }

  setSelectedSymbol(value: string): void {
    this.selectedSymbol = value;
  }

  setFilterOptions(options: MarketStatsFilterOptions): void {
    this.filterOptions = options;
  }
}
